import { useQuery } from 'react-query';
import { BoxStatus } from './useSubBoxStatuses';

export const useStatus = (boxId: number) => {
  const initialData = {
    boxId,
    isBattery: null,
    isOnline: false,
    isOpen: null,
    isUnlocked: null,
    requestStatus: null,
    updatedAt: null,
    updatedAtText: 'データがない',
  };
  const { data } = useQuery<BoxStatus>(['status', boxId], {
    initialData,
    staleTime: Infinity,
  });

  return data ?? initialData;
};

export default useStatus;
